import React from 'react';
import PropTypes from 'prop-types';
import './AspectRatioCardTitle.less';

const AspectRatioCardTitle = ({title}) => (
    <h4 className="AspectRatioCardTitle">{title}</h4>
);

AspectRatioCardTitle.propTypes = {
    /** The text to display. Text will be truncated as necessary. */
    title: PropTypes.string.isRequired
};

export default AspectRatioCardTitle;
